// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__XXj-R","footer_container":"footer_footer_container__Inu5B"};